"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ShowImagesTip;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _Image = _interopRequireDefault(require("@material-ui/icons/Image"));
var _excluded = ["email", "disabled", "showImages", "onShowImagesAnyway", "className"];
function ShowImagesTip(_ref) {
  var email = _ref.email,
    disabled = _ref.disabled,
    showImages = _ref.showImages,
    onShowImagesAnyway = _ref.onShowImagesAnyway,
    className = _ref.className,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, rest, {
    className: "flex p-2 bg-secondary items-center rounded-md mb-4"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-shrink-0"
  }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
    fontSize: "large",
    style: {
      color: 'rgb(196, 214,246)'
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-grow ml-2"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-gray-light text-sm "
  }, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    i18nKey: !showImages ? 'showImagesTip.title' : 'showImagesTip.action.alwaysShowImages',
    values: {
      email: email
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-dark"
  }))), !showImages && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("button", {
    disabled: disabled,
    className: "text-xs text-primary font-semibold",
    onClick: onShowImagesAnyway
  }, t('showImagesTip.action.showImagesAnyway')))));
}
//# sourceMappingURL=index.js.map